import {Skeleton} from '@kaman/uikit';

const StoreRowSkeleton = ({hasDivider = true}: {hasDivider?: boolean}) => (
    <div
        className={`flex min-h-[72px] w-full items-center gap-3 py-3 ${
            hasDivider ? 'border-b border-gray-200' : ''
        }`}
    >
        <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            className="!shrink-0 !rounded-lg"
        />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
            <Skeleton variant="rectangular" width="55%" height={22} className="!rounded" />
            <Skeleton variant="rectangular" width="75%" height={18} className="!rounded" />
        </div>
        <Skeleton variant="circular" width={20} height={20} />
    </div>
);

export default function OfflineSearchSkeleton({
    showSearchBar = true,
}: {
    showSearchBar?: boolean;
}) {
    return (
        <main
            className="flex w-full min-w-0 flex-col gap-5"
            dir="rtl"
            aria-busy="true"
            aria-label="در حال بارگذاری نتایج جستجوی فروشگاه‌های حضوری"
        >
            {showSearchBar ? (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={48}
                    className="!rounded-lg"
                />
            ) : null}

            <Skeleton
                variant="rectangular"
                width="100%"
                height={150}
                className="!rounded-lg"
            />

            <section className="w-full min-w-0">
                <div className="mb-2 flex items-center justify-between">
                    <Skeleton variant="rectangular" width="35%" height={28} className="!rounded" />
                    <Skeleton
                        variant="rectangular"
                        width={64}
                        height={28}
                        className="!rounded-full"
                    />
                </div>
                <div className="flex w-full min-w-0 flex-col">
                    {Array.from({length: 4}, (_, index) => (
                        <StoreRowSkeleton
                            key={index}
                            hasDivider={index < 3}
                        />
                    ))}
                </div>
            </section>
        </main>
    );
}
